import { cn } from '@/lib/utils';

/**
 * FlorealLogo — pure HTML+CSS logo (no SVG). More reliable across font-load
 * timings than <text> in SVG. Uses design tokens for size.
 *
 * Variants:
 *   - 'minimal' : just the wordmark FLOREAL (header use).
 *   - 'full'    : SINCE 1988 (top) + FLOREAL + ATELIER DEL FIORE (bottom).
 *                 Straight stacked (no arcs) — clean & readable at every size.
 */
export default function FlorealLogo({ variant = 'minimal', className = '', title = 'Floreal Atelier del Fiore' }) {
    if (variant === 'full') {
        return (
            <span
                role="img"
                aria-label={title}
                className={cn(
                    'inline-flex flex-col items-center justify-center leading-none select-none',
                    className,
                )}
            >
                <span className="text-[0.32em] tracking-[0.42em] font-serif font-medium opacity-85 mb-[0.35em]">
                    SINCE 1988
                </span>
                <span className="font-serif tracking-[0.24em] font-medium text-[1em]">
                    FLOREAL
                </span>
                <span className="text-[0.24em] tracking-[0.42em] font-serif font-medium opacity-85 mt-[0.4em]">
                    ATELIER DEL FIORE
                </span>
            </span>
        );
    }
    // Minimal wordmark
    return (
        <span
            role="img"
            aria-label={title}
            className={cn(
                'inline-block font-serif font-medium leading-none tracking-[0.32em] select-none',
                className,
            )}
        >
            FLOREAL
        </span>
    );
}
